import { version } from './version';

/** @internal */
export type Logger = {
  log: (...logs: (string | Record<string, string>)[]) => Promise<void>;
};

/** @internal */
function getVisit() {
  let visit = window?.tracking?.visit();
  if (visit) {
    return visit;
  }
  const cookie = document.cookie.split(';').find((c) => c.trim().startsWith('visit'));

  if (cookie) {
    visit = cookie.split('=')[1].trim();
  }
  return visit;
}

/** @internal */
export function initLogging(): Logger {
  const sendRequest = async (payload: string) =>
    await fetch(getLoggingUrl(window.location.hostname), {
      method: 'POST',
      body: payload,
      headers: {
        'Content-Type': 'application/json',
      },
    });

  const logCache: { [key: string]: boolean } = {};
  const logsId = Math.random().toString(36).substring(2, 15);
  return {
    log: async (...logs: (string | Record<string, string>)[]) => {
      try {
        const messageObjects = logs.reduce((accu, current) => {
          const messageKey = typeof current === 'string' ? current : (current.message as string);
          if (logCache[messageKey]) {
            return accu;
          }
          logCache[messageKey] = true;

          let messageObject: Record<string, string> = {};
          if (typeof current === 'string') {
            messageObject.message = current;
          } else {
            messageObject = { ...current };
          }
          accu.push(messageObject);
          return accu;
        }, new Array<Record<string, string>>());
        if (messageObjects.length === 0) {
          return;
        }
        await sendRequest(
          JSON.stringify([
            {
              common: {
                attributes: {
                  host: window.location.href,
                  agent: window.navigator.userAgent,
                  serviceName: 'ab-reader',
                  visit: getVisit(),
                  version,
                  logtype: 'browser',
                  logsId,
                },
              },
              logs: messageObjects,
            },
          ])
        );
      } catch (e) {
        console.error('ab-reader failed sending logs', JSON.stringify(e));
      }
    },
  };
}

function getLoggingUrl(hostname: string): string {
  let scriptSrc = 'https://nrlogger-prod.cf-exp.vpsvc.com?partition=exp';

  if (hostname === 'localhost' || hostname.startsWith('staging')) {
    scriptSrc = 'https://nrlogger-dev.cf-exp.vpsvc.com?partition=exp';
  }

  return scriptSrc;
}
